import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import YogurtProduct from 'models/YogurtProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Row, Alert, Input } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import { Controller, useFormContext, ErrorMessage } from 'react-hook-form'
import Switch from 'react-switch'
import { isNotNumericDecimal } from 'context/Utilities'
import { fatLevelOptions } from './constants'

const YogurtNutrition = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSwitch, asterisk, onChange } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      // current?.subCategory === packagingInitialState.subCategory
      fatLevelOptions
        .map(({ subCategory }) => subCategory)
        .includes(current?.subCategory)
    ) {
      const {
        category,
        subCategory,
        VitaminD,
        VitaminDCertification,
        Sugar,
        SugarCertification,
        SweetenerCertification,
      } = current
      setPackaging({
        category,
        subCategory,
        VitaminD,
        VitaminDCertification: VitaminDCertification ?? false,
        Sugar,
        SugarCertification: SugarCertification ?? false,
        SweetenerCertification: SweetenerCertification ?? false,
      })
    } else if (!updating) {
      setCurrent(YogurtProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Vitamin D mcg per 8 ounces {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="VitaminD"
            placeholder={'Min 2.67mcg per 8 ounces'}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 6,
                message: '⚠ Vitamin D mcg per 8 ounces exceeds 6 characters.',
              },
              required: {
                value: true,
                message: '⚠ Please enter Vitamin D mcg per 8 ounces.',
              },
              min: {
                value: 2.67,
                message:
                  '⚠ Vitamin D mcg per 8 ounces is below the required 2.67mcg minimum.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="VitaminD"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <p>
            <strong>Added Sugar (g) per 8 ounces {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Sugar"
            placeholder={'Max 16g added sugar per 8 ounces'}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 6,
                message: '⚠ Added Sugar (g) per 8 ounces exceeds 6 characters.',
              },
              max: {
                value: 16,
                message:
                  '⚠ Added Sugar (g) per 8 ounces exceeds the maximum allowed.',
              },
              required: {
                value: true,
                message: '⚠ Please enter Added Sugar (g) per 8 ounces.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Sugar"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product contains no less than 2.67mcg
              Vitamin D per 8 ounces. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="VitaminDCertification"
            id="VitaminDCertification"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.VitaminDCertification}
            rules={{
              validate: VitaminDCertification =>
                VitaminDCertification === true,
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="VitaminDCertification"
              message={
                '⚠ You must certify that this product contains no less than 2.67mcg Vitamin D per 8 ounces.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <p>
          <strong>
            I certify that this product contains no more than the maximum of 16g
            total added sugar per 8 ounces. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="SugarCertification"
          id="SugarCertification"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          checked={packaging.SugarCertification}
          rules={{
            validate: SugarCertification => SugarCertification === true,
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="SugarCertification"
            message={
              '⚠ You must certify that this product contains no more than the maximum of 16g total sugar per 8 ounces.'
            }
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>
            I certify that this product does not contain artificial sweeteners,
            reduced-calorie sweeteners, or no-calorie sweeteners. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="SweetenerCertification"
          id="SweetenerCertification"
          onChange={([checked, event, id]) => {
            setSwitch(checked, event, id)
            return checked
          }}
          control={methods.control}
          checked={packaging.SweetenerCertification}
          rules={{
            validate: SweetenerCertification => SweetenerCertification === true,
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="SweetenerCertification"
            message={
              '⚠ You must certify that this product does not contain artificial sweeteners, reduced-calorie sweeteners, or no-calorie sweeteners.'
            }
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

export default YogurtNutrition
